import { HIGHLIGHT_TYPES } from 'modules/codeless-events/consts/iframeParentConstants';
import { useElementHighlighter } from './useElementHighlighter';

const buttonSelector = 'button, a, [role="button"], input[type="button"], input[type="submit"], a';

export const useButtonHighlighter = ({ isHighlighting, onButtonClick }) => {
    const { clearHighlights } = useElementHighlighter({
        selector: buttonSelector,
        onElementClick: onButtonClick,
        highlightType: HIGHLIGHT_TYPES.POTENTIAL_ELEMENTS,
        isHighlighting,
    });

    return { clearHighlights };
};
